import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import Header from '../../components/Header';
import ObjectsMap from '../../components/objects/ObjectsMap';
import ObjectsFilterMobile from '../../components/objects/ObjectsFilterMobile';

const ObjectsMapPage = () => {
  return (
    <Fragment>
      <NextSeo
        title="Недвижимость на карте в Ростове-на-Дону, Азове, Новочеркасске и Батайске"
        description="Продажа недвижимости на карте в Ростове-на-Дону, Азове, Новочеркасске, Батайске. Купить квартиру недорого: найти на карте, цены, свежие объявления, срочная продажа."
        openGraph={{
          url: 'https://landlord.ru',
          type: 'website',
          title: 'Недвижимость на карте в Ростове-на-Дону, Азове, Новочеркасске и Батайске',
          description:
            'Продажа недвижимости на карте в Ростове-на-Дону, Азове, Новочеркасске, Батайске. Купить квартиру недорого: найти на карте, цены, свежие объявления, срочная продажа.',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <ObjectsFilterMobile isMap />
        <ObjectsMap />
      </main>
    </Fragment>
  );
};

export default ObjectsMapPage;
